import { gql, useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

const getDocument = gql`
  query getDocument($opId: String, $docNo: String) {
    getDocument(opId: $opId, docNo: $docNo) {
      ok
      error
      data
      message
    }
  }
`;

const useDocument = (opId: any, docNo: any) => {
  const [getComp, compData]: any = useLazyQuery(getDocument);

  useEffect(() => {
    if (opId || docNo) {
      getComp({ variables: { opId, docNo } });
    }
  }, [getComp, opId, docNo]);

  let document: any;
  const comp1 = compData?.data?.['getDocument']?.data || null;
  if (comp1) {
    document = JSON.parse(comp1);
  }

  return { document };
};

export default useDocument;
